import React from 'react';
import { Link } from 'react-router-dom';
import Maybe from 'react-maybe';
import PropTypes from 'prop-types';

import { MenuItemTypes, MenuItem } from '@ers/data';
import { Icon } from '@ers/ui';
import { useArchive } from '@ers/pages/home/Home.hooks';

const ArrowBack = ({ noReturn }) => {
    const archived = useArchive();
    const { url } = (archived ? MenuItem.get(MenuItemTypes.Archive) : MenuItem.get(MenuItemTypes.Home));
    return (
        <Maybe
            of={!noReturn}
            either={(
                <Link to={url()} className="arrow-back">
                    <Icon name="arrowBackBlue" />
                </Link>
            )}
            orElse={(
                <span className="arrow-back">
                    <Icon name="arrowBackBlue" />
                </span>
            )}
        />
    );
};
ArrowBack.propTypes = {
    noReturn: PropTypes.bool
};
ArrowBack.defaultProps = {
    noReturn: false
};

export default ArrowBack;
